import React, { useCallback, useEffect, useRef, useState } from "react";
import ProvidersLocationMap from "../components/map/ProvidersLocationMap";
import { SubHeader } from "../components/general/Header";
import { useNavigate } from "react-router-dom";
import useArtisanContext from "../hooks/useArtisanContext";
import axiosInstance from "../api/axios";
import useOpenModalContext from "../hooks/useOpenModalContext";
import Spinner from "../components/util/Spinner";
import ExploreOption from "../components/Modal/ExploreOption";

const POLLING_INTERVAL = 5000;
const MAX_ATTEMPTS = 10;

const RequestAvailableProviders = () => {
  const navigate = useNavigate();
  const {
    availableService,
    setAcceptedProvider,
    loadingAcceptedProvider,
    setLoadingAcceptedProvider,
    acceptedProvider,
  } = useArtisanContext();
  const { setOpenExplore } = useOpenModalContext();

  const [searchStatus, setSearchStatus] = useState(
    "Searching for providers..."
  );
  const [jobID, setJobID] = useState(null);
  const [isPolling, setIsPolling] = useState(false);

  const attemptsRef = useRef(0);
  const intervalRef = useRef(null);

  // Set job ID when available
  useEffect(() => {
    if (availableService?.job_detail?.id) {
      setJobID(availableService.job_detail.id);
    }
  }, [availableService]);

  // Core polling function
  const handleAcceptedProvider = useCallback(async () => {
    if (!jobID) return;

    setLoadingAcceptedProvider(true);
    setSearchStatus(
      `Searching... (Attempt ${attemptsRef.current + 1}/${MAX_ATTEMPTS})`
    );

    try {
      const response = await axiosInstance.get(
        `/service-user/api/v1/accepted-artisan/?job_id=${jobID}`
      );

      const providers = response?.data?.data;
      setAcceptedProvider(providers);

      if (providers?.length > 0) {
        setSearchStatus("Providers found!");
        setIsPolling(false);
        clearInterval(intervalRef.current);
      } else if (attemptsRef.current >= MAX_ATTEMPTS - 1) {
        setSearchStatus("No providers available. Expanding search...");
        setIsPolling(false);
        setOpenExplore(true);
        clearInterval(intervalRef.current);
      }
    } catch (err) {
      console.error("Polling error:", err);
      setSearchStatus("Connection issue. Retrying...");
    } finally {
      setLoadingAcceptedProvider(false);
      attemptsRef.current += 1;
    }
  }, [jobID, setAcceptedProvider, setLoadingAcceptedProvider, setOpenExplore]);

  // Start polling when jobID is set

  console.log("acceptedProvider", acceptedProvider);
  useEffect(() => {
    if (jobID) {
      attemptsRef.current = 0;
      setIsPolling(true);
      handleAcceptedProvider();

      intervalRef.current = setInterval(() => {
        if (attemptsRef.current < MAX_ATTEMPTS) {
          handleAcceptedProvider();
        }
      }, POLLING_INTERVAL);
    }

    return () => clearInterval(intervalRef.current);
  }, [jobID, handleAcceptedProvider]);

  return (
    <>
      <main className="w-screen h-screen flex flex-col md:items-center bg-page">
        <div className="relative p-5 md:w-1/3 bg-white rounded-md shadow-md h-full">
          <div className="absolute top-0 right-0 w-full p-5 z-50 bg-white">
            <SubHeader title={"Searching for Providers"} />
            <p className="ml-12 text-xs">
              Sending your request to providers around
            </p>
          </div>

          <div>
            <ProvidersLocationMap />
          </div>

          <div className="absolute bottom-0 right-0 p-5 bg-white w-full flex justify-around items-center">
            {isPolling ? (
              <div className="flex items-center gap-2 py-2 text-sm text-gray-600">
                <Spinner />
                <span>{searchStatus}</span>
              </div>
            ) : (
              <div className="flex items-center gap-5">
                <div className="border-4 animate-pulse items-center justify-center font-medium text-xl flex w-14 h-14 rounded-full">
                  {acceptedProvider?.length || 0}
                </div>
                <p className="flex flex-col">
                  <span className="font-medium text-sm">Service provider</span>
                  <span className="opacity-50 text-xs">
                    Have accepted your request
                  </span>
                </p>
              </div>
            )}

            {!isPolling && (
              <div>
                <button
                  onClick={() => navigate("/accepted-providers")}
                  className="btn-primary"
                >
                  View
                </button>
              </div>
            )}
          </div>
        </div>
      </main>
      <ExploreOption />
    </>
  );
};

export default RequestAvailableProviders;
